<div
  class="col-span-12 lg:col-span-6"
  [class.cursor-pointer]="!disableDealsCardClick()"
  [class.xl:col-span-3]="!dealsOnly()"
  [class.xl:col-span-6]="dealsOnly()"
  [routerLink]="disableDealsCardClick() ? null : '/admin/deal-management/deals/live'">
  <!-- Total Deals -->
  <app-card variant="elevated" rootClass="h-full" bodyClass="h-full" contentClass="h-full" class="h-full">
    <div class="flex h-full flex-col p-3">
      <div class="flex flex-col gap-3">
        <!-- HEADER -->
        <div class="flex items-start justify-between">
          <span class="title-text-primary text-subheading-large">
            {{ 'ADMIN.DASHBOARD.STATS.TOTAL_DEALS' | translate }}
          </span>

          <svg-icon src="./icons/total_deal.svg" width="20" height="20"></svg-icon>
        </div>
        <!-- VALUE -->
        <div class="text-heading-large text-primaryText">
          @if (profileLoading()) {
          <p-skeleton height="32px" width="70px" />
          } @else {
          {{ profileData()?.numberOfDeals ? profileData()?.numberOfDeals : '-' }}
          }
        </div>
      </div>
      <!-- DESCRIPTION -->
      <span class="mt-auto pt-3 text-body-large text-bodyText">
        {{ 'ADMIN.DASHBOARD.STATS.TOTAL_DEALS_DESCRIPTION' | translate }}
      </span>
    </div>
  </app-card>
</div>

@if (!dealsOnly()) {
<!-- Total WMs -->
<div class="col-span-12 lg:col-span-6 xl:col-span-3 cursor-pointer" routerLink="/admin/users/wealth-managers">
  <app-card variant="elevated" rootClass="h-full" bodyClass="h-full" contentClass="h-full" class="h-full">

    <div class="flex h-full flex-col p-3">
      <div class="flex flex-col gap-3">
        <!-- HEADER -->
        <div class="flex items-start justify-between">
          <span class="title-text-primary text-subheading-large">
            {{ 'ADMIN.DASHBOARD.STATS.TOTAL_WM' | translate }}
          </span>

          <svg-icon src="./icons/wealth.svg" width="20" height="20"></svg-icon>
        </div>

        <!-- VALUE -->
        <div class="text-heading-large text-primaryText">
          @if (profileLoading()) {
          <p-skeleton height="32px" width="70px" />
          } @else {
          {{ profileData()?.numberOfWealthManagers ? profileData()?.numberOfWealthManagers : '-' }}
          }
        </div>
      </div>

      <!-- DESCRIPTION -->
      <span class="mt-auto pt-3 text-body-large text-bodyText">
        {{ 'ADMIN.DASHBOARD.STATS.TOTAL_WM_DESCRIPTION' | translate }}
      </span>

    </div>

  </app-card>
</div>

<!-- Total RMs -->
<div class="col-span-12 lg:col-span-6 xl:col-span-3 cursor-pointer" routerLink="/admin/users/relationship-managers">
  <app-card variant="elevated" rootClass="h-full" bodyClass="h-full" contentClass="h-full" class="h-full">

    <div class="flex h-full flex-col p-3">
      <div class="flex flex-col gap-3">
        <!-- HEADER -->
        <div class="flex items-start justify-between">
          <span class="title-text-primary text-subheading-large">
            {{ 'ADMIN.DASHBOARD.STATS.TOTAL_RM' | translate }}
          </span>

          <svg-icon src="./icons/relationship_manager.svg" width="20" height="20">
          </svg-icon>
        </div>

        <!-- VALUE -->
        <div class="text-heading-large text-primaryText">
          @if (profileLoading()) {
          <p-skeleton height="32px" width="70px" />
          } @else {
          {{ profileData()?.numberOfRelationshipManagers ? profileData()?.numberOfRelationshipManagers : '-' }}
          }
        </div>
      </div>

      <!-- DESCRIPTION -->
      <span class="mt-auto pt-3 text-body-large text-bodyText">
        {{ 'ADMIN.DASHBOARD.STATS.TOTAL_RM_DESCRIPTION' | translate }}
      </span>

    </div>

  </app-card>

</div>

}

<!-- Total Investment -->
<div class="col-span-12 lg:col-span-6 cursor-pointer" [class.xl:col-span-3]="!dealsOnly()" [class.xl:col-span-6]="dealsOnly()" routerLink="/admin/users/clients">
  <app-card variant="elevated" rootClass="h-full" bodyClass="h-full" contentClass="h-full" class="h-full">

    <div class="flex h-full flex-col p-3">
      <div class="flex flex-col gap-3">
        <!-- HEADER -->
        <div class="flex items-start justify-between">
          <span class="title-text-primary text-subheading-large">
            {{ 'ADMIN.DASHBOARD.STATS.CLIENT_AUM' | translate }}
          </span>

          <svg-icon src="./icons/investment.svg" width="20" height="20">
          </svg-icon>
        </div>

        <!-- VALUE -->
        <div class="text-heading-large text-primaryText overflow-x-auto scrollbar-hide">
          @if (profileLoading()) {
          <p-skeleton height="32px" width="90px" />
          } @else {
          @if (profileData()?.totalInvestment) {
            <app-currency-display
              [value]="profileData()!.totalInvestment"
              currencyCode="USD"
              [compact]="true"
            />
          } @else {
            -
          }
          }
        </div>
      </div>

      <!-- DESCRIPTION -->
      <span class="mt-auto pt-3 text-body-large text-bodyText">
        {{ 'ADMIN.DASHBOARD.STATS.CLIENT_AUM_DESCRIPTION' | translate }}
      </span>

    </div>

  </app-card>

</div>
